<template>
  <div class="p-[16px_60px_20px] relative">
    <div v-if="canVideoCover" class="tabs">
      <span
        v-for="x in tabs"
        :key="x.key"
        :class="{ active: x.key === tabActive }"
        @click="onTabChange(x.key)"
      >
        {{ x.label }}
      </span>
    </div>
    <VideoView
      v-show="tabActive === CUSTUM_COVER.INTERCEPT && canVideoCover"
      ref="videoRef"
      autoplay
      muted
      loop
      :maxDuration="maxDuration"
      :videoUrl="videoUrl"
      @change="rangeData = $event"
      @onload="loading = false"
      @error="loading = false"
    />
    <Upload
      v-show="tabActive === CUSTUM_COVER.LOCAL"
      ref="uploadRef"
      @change="fileData = $event"
    />
    <div v-if="upLoading || loading" class="loading">
      <a-spin spinning />
    </div>
  </div>
  <div class="actionArea">
    <a-button class="w-[90px]" :disabled="loading" @click="cancel">
      {{ $t('qu-xiao') }}
    </a-button>
    <a-button
      type="primary"
      :disabled="!(fileData || rangeData)"
      :loading="loading || upLoading"
      @click="handOk"
    >
      {{ $t('she-wei-feng-mian') }}
    </a-button>
  </div>
</template>

<script lang="ts" setup>
import VideoView from './video.vue'
import Upload from './upload.vue'
import { CUSTUM_COVER } from '~/constants'
import { useDicts } from '~/utils/dict'
import { useUpload } from '~/hooks/useUpload'

const props = defineProps<{
  id: number
  videoUrl: string
  maxDuration: number
  success?: (range: { start_time: number; end_time: number }) => void
  uploadSuccess?: (link: string) => void
  cancel: () => void
}>()

const canVideoCover = computed(() => {
  const suffix = props.videoUrl
    ?.split('?')?.[0]
    ?.split('.')
    ?.pop()
    ?.toLowerCase()
  return suffix && !['mov', 'mkv'].includes(suffix)
})
const rangeData = ref<{ start_time: number; end_time: number }>()
const fileData = ref<string>()
const loading = ref(true)
const videoRef = ref()
const uploadRef = ref()
const tabs = useDicts('custumCover')
const tabActive = ref(canVideoCover.value ? tabs[0].key : tabs[1].key)

const { $t } = useNuxtApp()

const onTabChange = (key: string | number) => {
  tabActive.value = key
  fileData.value =
    key === CUSTUM_COVER.LOCAL
      ? uploadRef.value.fileUrl
      : videoRef.value.fileUrl
}

const { loading: upLoading, simpleUpload } = useUpload({
  accept: '*',
  hasMessage: false,
  onSuccess: async (_, res) => {
    loading.value = true
    try {
      message.success($t('shang-chuan-cheng-gong'))
      await props.uploadSuccess?.(res.upload_path)
    } catch {
      loading.value = false
    }
  },
})!

const handOk = async () => {
  if (rangeData.value) {
    await props.success?.(rangeData.value)
  }
  if (fileData.value) {
    const file = base64ConvertFile(fileData.value)
    await simpleUpload({ file })
  }
  props.cancel()
}
</script>

<style lang="scss" scoped>
.loading {
  @apply absolute top-0 left-0 w-full h-full flex-center bg-back-1 bg-opacity-60;
}
.tabs {
  @apply w-[202px] h-[34px] bg-back-3 m-[0_auto_16px] flex-center rounded-[8px] p-[2px];
  span {
    @apply text-14 text-font-50 h-full flex-1 text-center leading-[32px] rounded-[6px] cursor-pointer;
    &.active {
      @apply text-font-1 bg-back-1;
    }
  }
}

.actionArea {
  @apply p-[16px] flex-y-center justify-end gap-x-[16px];
  border: 1px solid var(--back-4);
}
</style>
